// Metadados do build, injetados em build time pelo scripts/build.js.
// Em dev (npm run start) caem nos fallbacks — operador sempre consegue
// identificar se esta numa build oficial ou local.
//
// Importe deste modulo em qualquer lugar que precise mostrar a versao
// (rodape do /login, sidemenu, payload de telemetria, /about, etc).

export const APP_VERSION = process.env.REACT_APP_VERSION || 'dev';
export const APP_COMMIT_SHA = process.env.REACT_APP_COMMIT_SHA || 'local';
export const APP_BUILD_AT = process.env.REACT_APP_BUILD_AT || '';
export const APP_BRANCH = process.env.REACT_APP_BRANCH || 'local';

// Data formatada YYYY-MM-DD (humano le data, nao SHA). Se nao houver
// build_at injetado (dev), retorna string vazia.
export const APP_BUILD_DATE = APP_BUILD_AT
  ? APP_BUILD_AT.slice(0, 10)
  : '';

// Label compacto pra rodape do /login e /sidemenu. Formato:
//   v 1.0.0 · 2026-05-26 · a3f9c1d
// Em dev (sem build date) cai pra:
//   v dev · build local
export const APP_VERSION_LABEL = APP_BUILD_DATE
  ? `v ${APP_VERSION} · ${APP_BUILD_DATE} · ${APP_COMMIT_SHA}`
  : `v ${APP_VERSION} · build ${APP_COMMIT_SHA}`;
